module.exports = __webpack_public_path__ + "media/images/bay-area-poverty-estimates-7c160ad3e01ea4ceb2fa978ef26ed9b9.png";